// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"_1fH6X4CeOG8F9mAKIIDblD","fadeIn":"_1yRWkeLYBduE3n3tCNx95","modal":"_9QpxUHsL3vkwTkjwoGLBl","fadeInDown":"_1x5bPmsTl0xytxtIOsw22F"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Modal/Modal.scss
 ** module id = 738
 ** module chunks = 0
 **/